/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, NavController, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { MainProcessProvider } from '../../../providers/processes/main';
import { Market_SessionStore } from './session.store';
import { Market_SessionParamsPopover } from './popovers/params/params';
import { Market_SessionSortPopover } from './popovers/sort/sort';
import { Market_SessionInstrumentPage } from '../sessionInstrument/sessionInstrument';
import { Trading_OrderPage } from '../../trading/order/order';

@Component({
  selector: 'page-market-session',
  templateUrl: 'session.html',
})
export class Market_SessionPage {
  @ViewChild(Content) private content: Content;
  private isBuzy = false;
  private isProcessing = false;
  constructor(
    // *** System
    private navCtrl: NavController,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private mainProcess: MainProcessProvider,
    private store: Market_SessionStore) {
    this.store.configParams(
      {
        showSearch: false,
        showFavorites: false,
        groups: '11,12,51,99',
        sortField: 'name',
        isDescSort: false,
        topTrades: 3
      }, true);
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
      this.store.loadParams().then(
        (succeed) => {
          this.store.load().then(
            (succeed) => {
              this.isBuzy = false;
              this.content.resize();
            },
            (error) => { this.isBuzy = false; }
          );
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Afficher/Cacher la barre de recherche
  private _toggleSearch() {
    try {
      this.store.params.showSearch = !this.store.params.showSearch;
      if (!this.store.params.showSearch)
        this.store.search(null);
      this.content.resize();
      this.store.persistParams();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recherche dans la liste des instruments
  private _doSearch(ev) {
    try {
      this.store.search(ev);
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Afficher/Cacher les favoris
  private _toggleFavorites() {
    try {
      this.isBuzy = true;
      this.store.params.showFavorites = !this.store.params.showFavorites;
      this.store.load(true).then(
        (succeed) => {
          this.isBuzy = false;
          this.content.resize();
          this.content.scrollToTop();
        },
        (error) => { this.isBuzy = false; }
      );
      this.store.persistParams();
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // Afficher la fenêtre de paramètres
  private _presentParams(ev) {
    try {
      let popover = this.popoverCtrl.create(Market_SessionParamsPopover);
      popover.present({ ev: ev });
      popover.onDidDismiss(
        (data) => {
          try {
            this.isBuzy = true;
            this.store.load(true).then(
              (result) => {
                this.isBuzy = false;
                this.content.resize();
                this.content.scrollToTop();
              },
              (error) => { this.isBuzy = false; }
            );
            this.store.persistParams();
          }
          catch (error) {
            this.isBuzy = false;
            this.globals.showUnknownError(this.toastCtrl, error);
          }
        });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // Afficher la fenêtre de paramètres de tri
  private _presentSort(ev) {
    try {
      let popover = this.popoverCtrl.create(Market_SessionSortPopover);
      popover.present({ ev: ev });
      popover.onDidDismiss(
        (data) => {
          try {
            this.store.sort();
            this.content.resize();
            this.content.scrollToTop();
            this.store.persistParams();
          }
          catch (error) {
            this.globals.showUnknownError(this.toastCtrl, error);
          }
        });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.content.scrollToTop();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }

  // *** Afficher la fiche instrument
  private _presentInstrument(instrument: any) {
    try {
      this.isProcessing = true;
      this.navCtrl.push(Market_SessionInstrumentPage, instrument.ISINCode);
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Afficher la fenêtre d'achat
  private _presentBuyOrder(instrument: any) {
    try {
      this.isProcessing = true;
      let params = {
        isNew: true,
        orderSide: 2,
        iSINCode: instrument.ISINCode
      }
      this.navCtrl.push(Trading_OrderPage, params);
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Afficher la fenêtre de vente
  private _presentSellOrder(instrument: any) {
    try {
      this.isProcessing = true;
      let params = {
        isNew: true,
        orderSide: 1,
        iSINCode: instrument.ISINCode
      }
      this.navCtrl.push(Trading_OrderPage, params);
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Afficher les transactions du marché
  private _presentSessionTrades() {
    try {
      this.isProcessing = true;
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Afficher la fiche indice du marché
  private _presentIndex() {
    try {
      this.isProcessing = true;
      this.isProcessing = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }

  // *** Ajouter/Retirer des favoris
  private _setFavorite(instrument: any) {
    try {
      this.isProcessing = true;
      instrument.IsFavorite = !instrument.IsFavorite;
      if (this.store.params.showFavorites) {
        let index: number = this.store.activeSession.instruments.indexOf(instrument);
        if (index !== -1)
          this.store.activeSession.instruments.splice(index, 1);
      }
      this.mainProcess.toggleFavorite(instrument.ISINCode).then(
        (succeed) => { this.isProcessing = false; },
        (error) => { this.isProcessing = false; }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isProcessing = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/session/session.ts